'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _FormattingUtils = require('../../utils/FormattingUtils');

var _FormattingUtils2 = _interopRequireDefault(_FormattingUtils);

var _CaseActivity = require('./CaseActivity');

var _CaseActivity2 = _interopRequireDefault(_CaseActivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var formatCaseLabelList = _FormattingUtils2.default.formatCaseLabelList,
    parseAndPreserveNewlines = _FormattingUtils2.default.parseAndPreserveNewlines;

var CaseTrackingUpdate = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(CaseTrackingUpdate, _Component);

  function CaseTrackingUpdate() {
    _classCallCheck(this, CaseTrackingUpdate);

    return _possibleConstructorReturn(this, (CaseTrackingUpdate.__proto__ || Object.getPrototypeOf(CaseTrackingUpdate)).apply(this, arguments));
  }

  _createClass(CaseTrackingUpdate, [{
    key: 'render',
    value: function render() {
      var _props$activity = this.props.activity,
          _props$activity$body = _props$activity.body,
          body = _props$activity$body === undefined ? '' : _props$activity$body,
          medical_status = _props$activity.medical_status,
          tracking_attributes = _props$activity.tracking_attributes,
          tracking_status = _props$activity.tracking_status,
          activityBody = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          'Case Update'
        ),
        tracking_status && _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'span',
            { className: 'status' },
            'Case Status:'
          ),
          ' ',
          formatCaseLabelList([tracking_status])
        ),
        medical_status && _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'span',
            { className: 'status' },
            'Medical Status:'
          ),
          ' ',
          formatCaseLabelList([medical_status])
        ),
        !!tracking_attributes.length && _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'span',
            { className: 'status' },
            'Attributes:'
          ),
          ' ',
          formatCaseLabelList(tracking_attributes)
        ),
        _react2.default.createElement(
          _Row2.default,
          { className: 'bloc' },
          parseAndPreserveNewlines(body)
        )
      );

      return _react2.default.createElement(_CaseActivity2.default, _extends({
        activity_body: activityBody,
        truncatedBody: this.trackingText,
        dot: 'icon',
        icon: 'flag'
      }, this.props));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'trackingText',
    get: function get() {
      var _props$activity2 = this.props.activity,
          tracking_attributes = _props$activity2.tracking_attributes,
          tracking_status = _props$activity2.tracking_status,
          tracking = [];


      if (tracking_status) {
        tracking.push('Status: ' + formatCaseLabelList([tracking_status]));
      }

      if (!(0, _isEmpty3.default)(tracking_attributes)) {
        tracking.push('Attributes: ' + formatCaseLabelList(tracking_attributes));
      }

      return tracking.join('; ');
    }
  }]);

  return CaseTrackingUpdate;
}(_react.Component), _class3.propTypes = {
  activity: _propTypes2.default.shape({
    body: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.string.isRequired,
    medical_status: _propTypes2.default.string,
    tracking_attributes: _mobxReact.propTypes.arrayOrObservableArray,
    tracking_status: _propTypes2.default.string,
    type: _propTypes2.default.string.isRequired
  }).isRequired
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'trackingText', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'trackingText'), _class2.prototype)), _class2)) || _class) || _class;

var _default = CaseTrackingUpdate;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(formatCaseLabelList, 'formatCaseLabelList', '/app/src/components/common-activities/CaseTrackingUpdate.js');
  reactHotLoader.register(parseAndPreserveNewlines, 'parseAndPreserveNewlines', '/app/src/components/common-activities/CaseTrackingUpdate.js');
  reactHotLoader.register(CaseTrackingUpdate, 'CaseTrackingUpdate', '/app/src/components/common-activities/CaseTrackingUpdate.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-activities/CaseTrackingUpdate.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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